import { Component, EventEmitter, inject, Input, Output, SimpleChanges } from "@angular/core";
import { ShopWindowItem } from "../../model/shop-window-item";
import { ProductService } from "../../services/product.service";

@Component({
    selector: "pme-assinatura-product",
    templateUrl: "./assinatura-product.component.html",
    styleUrls: ["./assinatura-product.component.scss"],
    standalone: false
})
export class AssinaturaProductComponent {
  @Input() activePlanValue: number;
  @Input() plan: ShopWindowItem;
  @Input() activePlanIdentifier: string;
  @Input() isCampaign: boolean = false;
  @Output() buyClicked = new EventEmitter<any>();

  isActivePlan: Boolean;
  buttonLabel: String;
  hiddenButton: Boolean = false;
  isNotCustomPlan: Boolean = false;
  hideDetails: Boolean = false;
  hideDetailsLabel: String;

  showCustomValueError: boolean = false;
  customPlanValue: number = 0;

  constructor(private productService: ProductService) { }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['plan'] && this.plan) {
      if (this.productService.isVariableProduct(this.plan.product)) {
        this.customPlanValue = this.plan.baseValue;
      }
    }
    this.updateButtonState();
  }

  private updateButtonState() {

    this.isActivePlan = this.plan.product?.identifier === this.activePlanIdentifier;
    this.isNotCustomPlan = !this.productService.isVariableProduct(this.plan.product);

    if (this.isActivePlan) {
      this.buttonLabel = "Você já possui este plano";
      this.hiddenButton = false;
    } else if (!this.activePlanIdentifier) {
      this.buttonLabel = "Assinar agora";
      this.hiddenButton = false;
    } else if (
      this.activePlanValue > 0 &&
      (this.plan.baseValue > this.activePlanValue || this.customPlanValue > this.activePlanValue)
    ) {
      this.buttonLabel = "Faça um upgrade";
      this.hiddenButton = false;
    } else {
      this.hiddenButton = true;
    }

    this.hideDetailsLabel = this.hideDetails ? "Ver mais detalhes" : "Esconder detalhes"

  }

  onBuyClick() {
    if (this.isActivePlan) return;
    this.buyClicked.emit(this.customPlanValue);
  }

  updateCustomPlanValue(value: string) {
    console.log('updateCustomPlanValue', value);
    this.customPlanValue = Number(value);
  }
  hideDetailsClick() {
    this.hideDetails = !this.hideDetails

    this.updateButtonState();
  }

  checkCustomValue(event: any) {
    const ninimumValue = this.plan.baseValue;

    if (this.customPlanValue < ninimumValue) {
      this.customPlanValue = ninimumValue;
      this.showCustomValueError = true;
      this.updateButtonState();
    } else {
      this.showCustomValueError = false;
      this.plan.featureList.forEach(feature => {
        feature.requests = Math.floor(this.customPlanValue / (Number(feature.toValue?.split("R$ ")[1].replace(",", ".")) || Number(feature.fromValue.split("R$ ")[1].replace(",", "."))));
      })
    }
  }
}
